export const LOGIN_USER = 'user/LOGIN_USER'
export const LOGIN_USER_SUCCESS = 'user/LOGIN_USER_SUCCESS'
export const LOGIN_USER_FAILURE = 'user/LOGIN_USER_FAILURE'

export const LOGOUT_USER = 'user/LOGOUT_USER'

export const REQUEST_FORGOT_PASSWORD = 'user/REQUEST_FORGOT_PASSWORD'
export const REQUEST_FORGOT_PASSWORD_SUCCESS = 'user/REQUEST_FORGOT_PASSWORD_SUCCESS'
export const REQUEST_FORGOT_PASSWORD_FAILURE = 'user/REQUEST_FORGOT_PASSWORD_FAILURE'
export const RESET_REQUEST_FORGOT_PASSWORD = 'user/RESET_REQUEST_FORGOT_PASSWORD'

export const REQUEST_RESET_PASSWORD = 'user/REQUEST_RESET_PASSWORD'
export const REQUEST_RESET_PASSWORD_SUCCESS = 'user/REQUEST_RESET_PASSWORD_SUCCESS'
export const REQUEST_RESET_PASSWORD_FAILURE = 'user/REQUEST_RESET_PASSWORD_FAILURE'
export const RESET_REQUEST_RESET_PASSWORD = 'user/RESET_REQUEST_RESET_PASSWORD'

export const FETCH_USERS = 'user/FETCH_USERS'
export const FETCH_USERS_SUCCESS = 'user/FETCH_USERS_SUCCESS'
export const FETCH_USERS_FAILURE = 'user/FETCH_USERS_FAILURE'
export const RESET_USERS = 'user/RESET_USERS'

export const FETCH_USER_DETAIL = 'user/FETCH_USER_DETAIL'
export const FETCH_USER_DETAIL_SUCCESS = 'user/FETCH_USER_DETAIL_SUCCESS'
export const FETCH_USER_DETAIL_FAILURE = 'user/FETCH_USER_DETAIL_FAILURE'
export const RESET_USER_DETAIL = 'user/RESET_USER_DETAIL'

export const CREATE_USER = 'user/CREATE_USER'
export const CREATE_USER_SUCCESS = 'user/CREATE_USER_SUCCESS'
export const CREATE_USER_FAILURE = 'user/CREATE_USER_FAILURE'
export const RESET_CREATE_USER = 'user/RESET_CREATE_USER'

export const UPDATE_USER = 'user/UPDATE_USER'
export const UPDATE_USER_SUCCESS = 'user/UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILURE = 'user/UPDATE_USER_FAILURE'
export const RESET_UPDATE_USER = 'user/RESET_UPDATE_USER'

export const DELETE_USER = 'user/DELETE_USER'
export const DELETE_USER_SUCCESS = 'user/DELETE_USER_SUCCESS'
export const DELETE_USER_FAILURE = 'user/DELETE_USER_FAILURE'
export const RESET_DELETE_USER = 'user/RESET_DELETE_USER'

export const UPLOAD_USER_PHOTO = 'user/UPLOAD_USER_PHOTO'
export const UPLOAD_USER_PHOTO_SUCCESS = 'user/UPLOAD_USER_PHOTO_SUCCESS'
export const UPLOAD_USER_PHOTO_FAILURE = 'user/UPLOAD_USER_PHOTO_FAILURE'
export const RESET_UPLOAD_USER_PHOTO = 'user/RESET_UPLOAD_USER_PHOTO'

export const DELETE_USER_PHOTO = 'user/DELETE_USER_PHOTO'
export const DELETE_USER_PHOTO_SUCCESS = 'user/DELETE_USER_PHOTO_SUCCESS'
export const DELETE_USER_PHOTO_FAILURE = 'user/DELETE_USER_PHOTO_FAILURE'
export const RESET_DELETE_USER_PHOTO = 'user/RESET_DELETE_USER_PHOTO'


// WEBPACK FOOTER //
// ./src/store/user/actionTypes.js